module.exports = __webpack_public_path__ + "static/media/phonepay.25318291.svg";